import Button from '@mui/material/Button'
import React from 'react'
import { useStyles } from './styles'
import { Icon, IconProps } from '@/shared/ui/icon'
import WebApp from '@twa-dev/sdk'
import { HapticFeedback as HapticFeedbackType } from '@twa-dev/types'

type GamedBtnProps = Omit<React.ComponentProps<typeof Button>, 'onClick' | 'variant'> & {
  children?: React.ReactNode
  onClick?: () => void
  variant?: 'primary' | 'secondary' | 'floating' | 'round'
  isLoading?: boolean
  impactStyle?: Parameters<HapticFeedbackType['impactOccurred']>[0] // types of parameters of impactOccurred
  icon?: IconProps['view']
  iconInvertColor?: boolean
  iconStyles?: React.CSSProperties
  iconAnimation?: 'rotation'
}

export const GamedBtn = ({ impactStyle = 'soft', variant = 'primary', ...props }: GamedBtnProps) => {
  const { classes } = useStyles({ classesOverrides: props.classes })

  const isDisabled = props.isLoading || props.disabled
  const paddingForIcon = () => {
    if (!props.icon) {
      return '0px'
    }
    if (props.icon && variant === 'floating') {
      return '0px'
    }
    return props.iconStyles?.width ? props.iconStyles?.width : '34.5px'
  }

  const isLoading = props.isLoading || false
  function handleClick() {
    if (props.onClick) props.onClick()
    WebApp.HapticFeedback.impactOccurred(impactStyle)
  }

  return (
    <button
      {...props}
      data-iconAnimation={props.iconAnimation}
      data-variant={variant}
      onClick={handleClick}
      className={classes.gamedBtn}
      disabled={isDisabled}
      style={{
        paddingRight: paddingForIcon(),
        ...props.style,
      }}
    >
      {props.icon && (
        <Icon
          view={props.icon}
          style={{
            width: variant === 'floating' ? '100%' : '24px',
            height: variant === 'floating' ? '100%' : '24px',
            ...props.iconStyles,
          }}
          invert={props.iconInvertColor || false}
        />
      )}
      {!isLoading && props.children}
      {isLoading && <span>Loading</span>}
    </button>
  )
}
